import { styled } from '@mui/material/styles';
import { Box, Box as MuiBox } from '@mui/material';
import { StyledCheckbox } from 'v3/shared/components/Checkbox';

export const MobileCardsWrapper = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '0rem',
  backgroundColor: 'transparent',
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const MobileCardContainer = styled(MuiBox)(({ theme }) => ({
  border: `0.0625rem solid ${theme.palette.divider}`,
  borderRadius: '0.5rem',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[0],
}));

export const MobileCardLine = styled(MuiBox)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const MobileCardCheckboxContainer = styled(MuiBox)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

export const StyledCheckboxTermsMobile = styled(StyledCheckbox)(({ theme }) => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
  padding: '0rem',
  marginRight: '1.25rem',
  '&.Mui-disabled': {
    cursor: 'not-allowed',
  },
  '&.Mui-disabled .MuiSvgIcon-root': {
    color: theme.palette.secondary.main,
  },
  '&.Mui-disabled .MuiFormControlLabel-label': {
    color: theme.palette.text.disabled,
  },
}));

export const TextOpacity = styled(Box)(() => ({
  opacity: '0.5',
}));

export const MobileCardFooterBoxStyled = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderTop: `0.0625rem solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.primary.main,
  borderRadius: `0.5rem`,
  marginTop: theme.spacing(2),
}));